import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Edit2, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import DeleteLandingPageBrandModal from './modals/DeleteLandingPageBrandModal';
import AddLandingPageGlobalProductModal from './modals/AddLandingPageGlobalProductModal';
import { apiFetch, API } from "../services/api";

function getLandingPageGlobalProducts() {

    return apiFetch(API.back + '/landing-page-global-products', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getPosts() {

    return fetch('https://back-api.therunningcollective.fr/blog-posts', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getProducts() {

    return fetch('https://back-products-api.therunningcollective.fr/small-products?headCategories=/products/shoes,/products/apparel,/products/spikes,/products/electronic,/products/accessories,/products/nutrition', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class LandingPageGlobalProductsList extends Component{
    state = {
        landingPages: null,
        blogCategories: null,
        productCategories: null,
        isOpen: false,
        errors: null,
        selectedLandingPage: {
            title : "",
            description: "",
            brand: "",
            slug: "",
            keywords: "",
            metaTitle: "",
            metaDescription: "",
            toKnow: {
                name: "",
                categories: []
            },
            links: []
        }
    }

    async componentDidMount() {
        await getLandingPageGlobalProducts().then(data => {
            this.setState({ landingPages: data })
        }).catch(err =>
                console.log(err),
            this.setState({errors: "error while getting landingPageBrands"})
        );
        await getProducts().then(data => {
            this.setState({ availableProducts: data })
        });
        await getPosts().then(data => {
            this.setState({ availablePosts: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting posts"})
        );
    };

    closeModal = () => this.setState({ isOpen: false, selectedLandingPage: {
            title : "",
            description: "",
            slug: "",
            keywords: "",
        } });

    render(){

        return(
            <div className="products-list">
                <Row>
                    {
                        this.state.availableProducts ?
                            <Col sm={11} className="products-buttons">
                                <Button className="add-product-button " variant="secondary" type="submit"onClick={(e) => this.setState({isOpen : true})}>Ajouter une landing page d'une franchise produit</Button>
                            </Col>
                        : null
                    }
                </Row>
                { (!this.state.landingPages) ? <p> Aucune landing page disponible.</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Description</th>
                            <th>Slug</th>
                            <th>Marque</th>
                            <th>Couverture</th>
                            <th>Image sponsorisée</th>
                            <th>Produits associés</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.landingPages.map(landingPage => (
                            <tr key={landingPage.id}>
                                <td>{landingPage.title}</td>
                                <td>{landingPage.description}</td>
                                <td>{landingPage.slug}</td>
                                <td>{landingPage.brand}</td>
                                <td>
                                    <img style={{
                                        maxWidth: '100px',
                                    }} src={landingPage.backgroundImage}/>
                                </td>
                                <td>
                                    <img style={{
                                        maxWidth: '100px',
                                    }} src={landingPage.sponsoredImage}/>
                                </td>
                                <td>{landingPage.products ? landingPage.products.length : 0}</td>
                                {
                                    this.state.availableProducts ?
                                        <td className="table-action">
                                            <Edit2 className="align-middle mr-1" size={18} onClick={(e) => this.setState({isOpen : true, selectedLandingPage : landingPage})} style={{cursor: "pointer"}}/>
                                        </td>
                                        : null
                                }
                                <td className="table-action">
                                    <Trash className="align-middle" size={18}onClick={(e) => this.setState({isDelete: true, selectedLandingPage: landingPage})} style={{cursor: "pointer"}}/>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    }

                { this.state.isOpen ?
                    <AddLandingPageGlobalProductModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        selectedLandingPage={this.state.selectedLandingPage}
                        availableProducts={this.state.availableProducts}
                        availablePosts={this.state.availablePosts}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteLandingPageBrandModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedLandingPage}
                        selectedCategory="landing-page"
                    />
                    :
                    null
                }
            </div>
        );

    }

}
